// extracted by mini-css-extract-plugin
module.exports = {"EditorSettings":"_3YmbLZyQ","firstBlock":"_2XXSAZ2l","titleBlock":"_1odlKJoP","title":"_39wDRNS2","scrollDiv":"_7yiW0aeM","titleContainer":"lNClequ9","input":"_2TFb7enf","inputContainer":"_2_IyFIOY","autoSaving":"zCa2omxT","autoSaved":"_2nvjgYL9","saveContent":"_25xJbQgv","label":"_1HI0_7xe","errorText":"_3-todZuR","emailContent":"_3ZY9r0TT","backButton":"_2wItMIuv","backButtonContainer":"o_2j60bn"};
    if(module.hot) {
      // 1754515035719
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  